import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  isHiddenSignal: PropTypes.bool,
};
const defaultProps = {
  isHiddenSignal: false,
};

const withHiddenSignal = (WrappedComponent, isHiddenSignal) => {
  const HiddenSignalComponent = (props) => {
    if (isHiddenSignal) {
      return (
        <div className="d-flex align-items-center">
          <span className="font-weight-medium tx-12 mx-2 underline-operator">Signal is Hidden</span>
        </div>
      );
    }
    return <WrappedComponent {...props} />;
  };
  HiddenSignalComponent.displayName = `withHiddenSignal(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  return HiddenSignalComponent;
};

withHiddenSignal.propTypes = propTypes;
withHiddenSignal.defaultProps = defaultProps;

export default withHiddenSignal;
